import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import firebase from "firebase/app";
import "firebase/firestore";
import store from './store';
import _ from 'lodash';
import * as moment from 'moment';
import mixin from './mixin';
import vueXlsxTable from 'vue-xlsx-table';
import ExcelButton from './components/ExcelButton';
import * as VueGoogleMaps from 'vue2-google-maps';
import Axios from "axios";

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCZgj6nOL3lt5LSLzdQzIDxc_Gj7BCV83s',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
    region: 'LA',
    language: 'la',
  },
});
Axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://us-central1-naoki-c4da8.cloudfunctions.net/' : 'http://localhost:5000/naoki-c4da8/us-central1/';

Axios.interceptors.response.use(
  response => {
    return response ? response.data : null;
  },
  error => {
    return Promise.reject(error);
  }
);

Vue.component('ExcelButton', ExcelButton);
Vue.use(vueXlsxTable, {
  rABS: false
});
Vue.use(BootstrapVue);
var firebaseConfig = {
  apiKey: "AIzaSyB0XfhMTHCCkUxiKVctHFSMKKsfuS8Lj_s",
  authDomain: "naoki-c4da8.firebaseapp.com",
  databaseURL: "https://naoki-c4da8.firebaseio.com",
  projectId: "naoki-c4da8",
  storageBucket: "naoki-c4da8.appspot.com",
  messagingSenderId: "31689967544",
  appId: "1:31689967544:web:ed3155ab6e7ff30f"
};
firebase.initializeApp(firebaseConfig);
Vue.use(firebase);
Vue.mixin(mixin);
Object.defineProperty(Vue.prototype, '_', {
  value: _
});
Object.defineProperty(Vue.prototype, 'moment', {
  value: moment
});
let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
